

























import { Component, Mixins, Prop } from "vue-property-decorator";
import { FixedLoading } from "../system";
import { ExistingDocumentEditor } from "./editors";
import {
  EmbeddedDocumentEditViewMixin,
} from "./mixins";

@Component({
  components: {
    FixedLoading,
    ExistingDocumentEditor,
  },
})
export default class EmbeddedDocumentEditView extends Mixins(EmbeddedDocumentEditViewMixin) {
  @Prop()
  documentId: number;

  @Prop()
  orderNo: string;

  mounted() {
    this.embeddedComponent = this.$refs.editor;
  }
}
